import * as Sentry from '@sentry/vue';
export function setSentryUser(user) {
    if (!user || !user.id || !user.email) {
        Sentry.setUser(null);
        return;
    }
    Sentry.setUser({
        id: String(user.id),
        email: user.email,
        username: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        role: user.role,
        type: user.type,
        systemRole: user.systemRole,
    });
}
export function getUserContextForSentry(user) {
    if (!user?.id || !user?.email) {
        return null;
    }
    return {
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        role: user.role,
        type: user.type,
        systemRole: user.systemRole,
    };
}
export function addUserToSentryScope(scope, user) {
    if (!user || !user.id || !user.email) {
        return;
    }
    scope.setUser({
        id: String(user.id),
        email: user.email,
        username: user.email,
    });
    scope.setContext('user_details', {
        firstName: user.firstName,
        lastName: user.lastName,
        role: user.role,
        type: user.type,
        systemRole: user.systemRole,
    });
}
